import { render, staticRenderFns } from "./ArticlesDetail.vue?vue&type=template&id=7fc52734&scoped=true"
import script from "./ArticlesDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticlesDetail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ArticlesDetail.vue?vue&type=style&index=0&id=7fc52734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc52734",
  null
  
)

export default component.exports